<div class="px-4 xl:px-6 pt-6" id="deck_admin_shell">
  <!-- Title -->
  <div class="flex items-center gap-2.5 flex-wrap">
    <h1 class="text-xl font-bold text-slate-800 dark:text-white tracking-tight">Live Call Management</h1>
  </div>
  <p class="text-sm text-slate-500 dark:text-slate-400 mt-0.5">
    Manage the product's content deck and assistant configuration. Switch products from the sidebar.
  </p>

  <!-- Tab bar -->
  <div class="flex items-center gap-1 border-b border-slate-200 dark:border-slate-700/50 mt-5" id="deck_admin_tabs">
    <button type="button" (click)="setTab('deck')"
      class="flex items-center gap-2 px-4 py-2.5 text-sm font-semibold border-b-2 -mb-px transition-colors"
      [class.border-purple-500]="activeTab() === 'deck'" [class.text-purple-600]="activeTab() === 'deck'"
      [class.dark:text-purple-400]="activeTab() === 'deck'" [class.border-transparent]="activeTab() !== 'deck'"
      [class.text-slate-500]="activeTab() !== 'deck'" [class.hover:text-slate-700]="activeTab() !== 'deck'"
      [class.dark:hover:text-slate-300]="activeTab() !== 'deck'" id="deck_admin_tab_deck">
      <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
      </svg>
      Content Deck
      <span *ngIf="deckCount() !== null"
        class="text-[10px] px-1.5 py-0.5 rounded-full bg-slate-100 dark:bg-slate-700/60 text-slate-500 dark:text-slate-400 font-bold">
        {{ deckCount() }}
      </span>
    </button>

    <button type="button" (click)="setTab('prompts')"
      class="flex items-center gap-2 px-4 py-2.5 text-sm font-semibold border-b-2 -mb-px transition-colors"
      [class.border-purple-500]="activeTab() === 'prompts'" [class.text-purple-600]="activeTab() === 'prompts'"
      [class.dark:text-purple-400]="activeTab() === 'prompts'" [class.border-transparent]="activeTab() !== 'prompts'"
      [class.text-slate-500]="activeTab() !== 'prompts'" [class.hover:text-slate-700]="activeTab() !== 'prompts'"
      [class.dark:hover:text-slate-300]="activeTab() !== 'prompts'" id="deck_admin_tab_prompts">
      <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="8" r="6"></circle>
        <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"></path>
      </svg>
      Assistant config
      <span *ngIf="promptCount() !== null"
        class="text-[10px] px-1.5 py-0.5 rounded-full bg-slate-100 dark:bg-slate-700/60 text-slate-500 dark:text-slate-400 font-bold">
        {{ promptCount() }}
      </span>
    </button>
  </div>
</div>

<!-- Tab bodies (both mounted; toggled so state and instant switching are preserved) -->
<div [hidden]="activeTab() !== 'deck'">
  <app-deck-board (countChange)="deckCount.set($event)"></app-deck-board>
</div>
<div [hidden]="activeTab() !== 'prompts'">
  <app-agent-admin (countChange)="promptCount.set($event)"></app-agent-admin>
</div>